<div class="section  padding-top p-4 background-rana-footer " id="footer">
    <div class="text-center">
        <div class="container-fluid">
            <div>
                <p class="mb-0 size-14 text-footer mt-1 font-weight-500">
                    &copy; {{ fullYear }} Copyright | Rajput Association Of North America | All Rights Reserved
                    | <a class="faq-link" routerLink="/help-faq">FAQ</a>
                </p>
            </div>
        </div>
    </div>
</div>


